import { IGetCanSubmitParams } from "./types";

export const getCanSubmit = ({
  seasonName,
  submitting,
}: IGetCanSubmitParams) => {
  return Boolean(seasonName.trim()) && submitting === undefined;
};



// WEBPACK FOOTER //
// ./src/features/director/pages/seasons/components/seasons-editor/components/add-season-modal/utils/get-can-submit/getCanSubmit.ts